module.exports = "/_next/static/images/ec0f399464e8d3173cbc87553c3f486a-mgm-invite-ticket-2.jpg";